import React from "react";

export const AwModalTitle = props => {
  return (
    <span className="aw-no-user-select" style={{ fontWeight: "700" }}>
      {props.children}
    </span>
  );
};
